import { useQuery } from "@tanstack/react-query";

import { getDairyHerdDetails } from "services";

import { DEFAULT_CACHE_TIME, GET_DAIRY_HERD_DETAILS } from "consts";

import { FootprintingDairyHerdDetails } from "models";

export const useGetFootprintingDairyHerdDetails = (primaryDataId: string, options?: { enabled?: boolean }) =>
  useQuery<FootprintingDairyHerdDetails>({
    queryKey: [GET_DAIRY_HERD_DETAILS, primaryDataId],
    queryFn: () => getDairyHerdDetails(primaryDataId),
    enabled: options?.enabled !== false && !!primaryDataId,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
